var map = {
	"./authorize.svg": 1284,
	"./canceled.svg": 1285,
	"./capture.svg": 1286,
	"./card-authentication-line.svg": 1287,
	"./collect-card.svg": 1288,
	"./created.svg": 1289,
	"./failed.svg": 1290,
	"./processing.svg": 1291,
	"./requires-action-line.svg": 1292,
	"./requires-confirmation.svg": 1293,
	"./requires-payment-method.svg": 1294,
	"./succeeded.svg": 1295,
	"./verified.svg": 1296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1283;